var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[(_vm.amount)?_c('div',{class:_vm.$style.badge},[_c('Typography',{attrs:{"variant":_vm.TYPOGRAPHY_TYPES.bodySmallBold}},[_vm._v("\n      "+_vm._s(_vm.amount)+"\n    ")])],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }